import { __ } from "@wordpress/i18n";
import { withSelect } from "@wordpress/data";
const { InspectorControls } = wp.blockEditor;

import { ClipboardButton, TabPanel, Panel, PanelBody, PanelRow, Snackbar } from "@wordpress/components";
import { useState } from "@wordpress/element";
import ModelForm from "./Components/Tabs/General/ModelForm";
import Style from "./Components/Tabs/Style/Style";
import Additional from "./Components/Tabs/Style/Additional";
import Options from "./Components/Tabs/General/Options";

const Settings = ({ attributes, setAttributes, postId, postType }) => {
  const [copied, setCopied] = useState(false);

  return (
    <InspectorControls>
      {postType === "bp3d-model-viewer" && (
        <PanelBody>
          <PanelRow>
            <div className="b3dviewer_front_shortcode justify-center">
              <ClipboardButton title={copied ? __("Copied", "model-viewer") : ""} variant="primary" text={`[3d_viewer id=${postId}]`} onCopy={() => setCopied(true)} onFinishCopy={() => setCopied(false)}>
                {__("Copy Shortcode", "model-viewer")}
              </ClipboardButton>
              {copied && <Snackbar>{__("Copied Succesfully", "model-viewer")}</Snackbar>}
            </div>
          </PanelRow>
        </PanelBody>
      )}
      <TabPanel
        className="b3dviewer-tab-panel"
        activeClass="active"
        tabs={[
          {
            name: "settings",
            title: __("Settings", "b3d-viewer-lite"),
            className: "settings",
          },
          {
            name: "style",
            title: __("Style", "b3d-viewer-lite"),
            className: "style",
          },
        ]}
      >
        {(tab) => {
          return (
            <span>
              {tab.name === "settings" && (
                <Panel>
                  <ModelForm attributes={attributes} setAttributes={setAttributes} />
                  <Options attributes={attributes} setAttributes={setAttributes} />
                </Panel>
              )}
              {tab.name === "style" && (
                <Panel>
                  <Style attributes={attributes} setAttributes={setAttributes} />
                  <Additional attributes={attributes} setAttributes={setAttributes} />
                </Panel>
              )}
            </span>
          );
        }}
      </TabPanel>
    </InspectorControls>
  );
};

export default withSelect((select) => {
  const postType = select("core/editor")?.getCurrentPostType() || "product";
  const postId = select("core/editor")?.getCurrentPostId();

  return {
    postId,
    postType,
  };
})(Settings);
